export default {
  ADD_TAG (state, tag) {
    state.tags.unshift(tag)
  },
  SET_TAG (state, tags) {
    state.tags = tags
  },
  UPDATE_TAG (state, tag) {
    const tagIndex = state.tags.findIndex((p) => p._id === tag._id)
    Object.assign(state.tags[tagIndex], tag)
  },
  REMOVE_TAG (state, tagId) {
    const tagIndex = state.tags.findIndex((p) => p._id === tagId)
    state.tags.splice(tagIndex, 1)
  }
}
  